import { Component, Input, OnInit } from '@angular/core';
import {
  DetailSearchConfiguration,
  OmniApi,
  SearchRequest,
  SearchService,
  Session,
  TranslationService,
} from 'src/app/my-sedgwick';
import { OmniNotifications } from 'src/app/my-sedgwick/models/accommodation';
import { BaseComponent, LoadingState } from 'src/app/shared';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-notifications-page',
    template: `
    <app-section>
      <div class="app-pl2 tw-w-full">
        <app-claim-breadcrumb></app-claim-breadcrumb>
      </div>
      <app-panel
        title="Notifications"
        [headerLevel]="1"
        class="tw-w-full"
        [canExpand]="false"
      >
        <div class="tw-min-h-[510px] tw-w-full">
          <app-detail-search-form
            #searchForm
            [config]="config"
            (search)="search($event)"
            [loading]="loading"
            [translationRequest]="translationRequest"
          >
            <ng-template #results>
              <app-search-count-row
                resultSingle="Notification"
                resultPlural="Notifications"
                [count]="notificationAcommodations.length"
                [isInDirectInclude]="isInDirectReporting"
                [isSupervisor]="isSupervisorSelect"
                [supervisorFullName]="SupervisorFullName"
              ></app-search-count-row>
              <app-notifications-list
                [notifications]="notificationAcommodations"
                class="tw-w-full"
                (export)="searchForm.appendExport($event)"
                [translationRequest]="translationRequest"
              >
              </app-notifications-list>
            </ng-template>
          </app-detail-search-form>
        </div>
      </app-panel>
    </app-section>
  `,
    styles: [``],
    standalone: false
})
export class NotificationsPageComponent
  extends BaseComponent
  implements OnInit
{
  config = new DetailSearchConfiguration();
  loading: LoadingState;
  notificationAcommodations: OmniNotifications[];
   isSupervisorSelect : boolean = false;
  SupervisorFullName : string = '';
  isInDirectReporting : boolean = false;

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Search',
    subGroup: 'Search',
  });

  constructor(private OmniApi: OmniApi,
    private translationService: TranslationService,
    private session: Session
  ) {
    super();
    this.config.key = 'omni-dashboard:notification-accommodations';
    this.config.ssn.visible = false;
    this.config.status.visible = false;
    this.config.lob.visible = true;
    this.config.supervisor.visible = false;
    this.config.includeIndirect.visible = false;
    this.config.employeeId.widthPercent = 25;
    this.config.initialSearch = true;
    this.config.initialSearchResultsOnClear = true;
    this.config.managerLookupSupervisor = false;
    this.config.showParametersToggle = true;
    this.config.expanded = false;
    this.config.payType.visible = false;
    this.config.maxBackDays = 730;
    this.config.alertType.visible = true;
  }

  loadTranslations(): void {
    this.translationRequest.contNum = Number(this.session.user.contNum);
    this.translationService.getTranslation(this.translationRequest);
  }

  verifyIndirectReport() {
    const includeIndirectsInSession = sessionStorage.getItem(
      this.session.user.sessionId + 'includeIndirects_summary'
    );

    if (includeIndirectsInSession == undefined || includeIndirectsInSession == null || includeIndirectsInSession.length < 2) {
      return false;
    }
    else {
      return includeIndirectsInSession == 'true';
    }


  }
  verifyFilterByManager() {
    const filteredManagerInSession = sessionStorage.getItem(
      this.session.user.sessionId + 'filteredManager_summary'
    );

    if (filteredManagerInSession == undefined || filteredManagerInSession == null || filteredManagerInSession.length < 2) {
      return false;
    }
    else {
      return true;
    }
  }
  ngOnInit(): void {
    this.loadTranslations();
    this.config.startDate.widthPercent = 25;
    this.config.endDate.widthPercent = 25;

    if(this.verifyFilterByManager())
    {
      this.isSupervisorSelect = this.verifyFilterByManager();
       const filteredManagerInSession = sessionStorage.getItem(
        this.session.user.sessionId + 'filteredManager_summary');
      const supervisor = JSON.parse(filteredManagerInSession);
      this.SupervisorFullName = supervisor.name;
      this.isInDirectReporting = this.verifyIndirectReport();
    }
  }

  override ngOnDestroy(): void {
    this.config.initialSearch = true;
  }

  async search(request: SearchRequest) {
    // TODO: Update this block if needed for search
    this.loading = 'Loading';
    const params = request.getParameters();
    params.status = ['O'];
    params.excludeSupervisor = true;

     if(this.verifyFilterByManager())
    {      
       const filteredManagerInSession = sessionStorage.getItem(
        this.session.user.sessionId + 'filteredManager_summary');
      const supervisor = JSON.parse(filteredManagerInSession);
      params.supervisor = supervisor;
      params.managerEmpUnum = supervisor.empUnum;
    }
    else{
      params.supervisor = null;
      params.managerEmpUnum = null;
    }

     if (this.verifyIndirectReport()) {
      const includeIndirectsInSession = sessionStorage.getItem(
        this.session.user.sessionId + 'includeIndirects_summary'
      );
      params.includeIndirectReports = includeIndirectsInSession.toLowerCase() == 'true';
    }
    else {
      params.includeIndirectReports = false;
    }
   

    const searchInformation = await this.OmniApi.getNotificationAccomodations(
      params
    );
    this.config.initialSearch = false;
    this.notificationAcommodations = searchInformation;
    this.loading =
      this.notificationAcommodations.length > 0 ? 'Loaded' : 'Empty';
  }
}
